import React, { useState } from 'react'
import { StyleSheet, Text } from 'react-native'
import Button from '../../../../components/Button'
import Input from '../../../../components/Input'
import Spinner from '../../../../components/Spinner'
import ServiceType from '../../../../models/service-type'
import { saveServiceType } from '../../../../services/api'
import { SystemRole } from '../../../../shared/consts'
import { isEmpty } from '../../../../shared/utils'

export interface ServiceTypeFormProps {
    originalServiceType?: ServiceType
    onBack: () => void
    privilege: number
}

const ServiceTypeForm = ({
    originalServiceType,
    onBack,
    privilege,
}: ServiceTypeFormProps) => {
    const [name, setName] = useState(originalServiceType?.name || '')
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const _save = async () => {
        if (isEmpty(name)) {
            setErrorMessage('Por favor, informe o nome do tipo de serviço.')
        } else {
            setErrorMessage('')
            setLoading(true)
            try {
                const data = {
                    serviceType: {
                        id: 0,
                        name: name.trim(),
                    },
                }
                if (originalServiceType) {
                    data.serviceType.id = originalServiceType.id
                }

                const result = await saveServiceType(data)
                if (originalServiceType && result) {
                    // setEditing(false)
                    // const r = new Statement(result.statement)
                    // onStatementUpdated(r)
                } else {
                    onBack()
                }
            } catch (e) {
                console.log('ServiceTypeForm exception: ', e)
                setErrorMessage(
                    'Erro inesperado. Verifique sua conexão com a internet e tente novamente.',
                )
            } finally {
                if (originalServiceType) {
                    setLoading(false)
                }
            }
        }
    }

    return (
        <>
            {errorMessage.length > 0 ? (
                <Text style={styles.errorMessage}>{errorMessage}</Text>
            ) : null}
            <Input
                returnKeyType="next"
                autoCapitalize="words"
                style={{ marginBottom: 12 }}
                label="Nome"
                value={name}
                editable={SystemRole.isSuperAdmin(privilege)}
                onChangeText={setName}
            />

            <Button
                primary
                style={{ marginTop: 12, marginBottom: 10 }}
                label="Salvar"
                disabled={!SystemRole.isSuperAdmin(privilege)}
                onPress={_save}
            />
            <Button
                secondary
                style={{ marginBottom: 50 }}
                label="Cancelar"
                onPress={onBack}
            />
            <Spinner visible={loading} />
        </>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    errorMessage: {
        color: 'red',
        fontSize: 14,
        marginBottom: 10,
    },
})

export default ServiceTypeForm
